export const SUPPORTED_ICON_NAMES = [
  'adobe',
  'adobefirefly',
  'adobeicon',
  'adobeillustrator',
  'ae',
  'affinity',
  'affinitydesigner',
  'affinityphoto',
  'affinitypublisher',
  'ai21labsai',
  'ai2ai',
  'ai360',
  'aihubmix',
  'aimass',
  'aionlabs',
  'airtable',
  'aistudio',
  'alacritty',
  'algolia',
  'algorand',
  'alibabacloud',
  'alpinejs',
  'amp',
  'amplitude',
  'amznwebserv',
  'analytics',
  'android',
  'angular',
  'angular17',
  'animaapp',
  'antd',
  'antgroup',
  'anthropic',
  'antigravity',
  'anyscale',
  'apache',
  'appwrite',
  'arc',
  'arceeai',
  'asana',
  'assemblyai',
  'astro',
  'atlassian',
  'atom',
  'augment',
  'auth0',
  'automatic',
  'avajs',
  'aws',
  'axiom',
  'axm',
  'axure',
  'aya',
  'azure',
  'azureai',
  'baaiai',
  'babel',
  'backbonejs',
  'baichuan',
  'baidu',
  'baiducloud',
  'baseui',
  'bash',
  'bedrock',
  'bilibiliai',
  'bing',
  'biomejs',
  'bitbucket',
  'bitnami',
  'blitz',
  'blueprintjs',
  'bolt',
  'bootstrap4',
  'bootstrap5',
  'brave',
  'brunch',
  'builder',
  'buildship',
  'bulmaui',
  'bunjs',
  'bytedance',
  'cakephp',
  'canva',
  'cassandradb',
  'centml',
  'cerebras',
  'chakraui',
  'chatglm',
  'chrome',
  'chromium',
  'circleci',
  'civitai',
  'claude',
  'clerk',
  'clickhouse',
  'cline',
  'clojure',
  'cloudflare',
  'cloudinary',
  'codefresh',
  'codegeex',
  'codeigniter',
  'coderabbit',
  'cogvideo',
  'cogview',
  'colab',
  'comfyui',
  'commanda',
  'commandai',
  'convex',
  'copilotgithub',
  'copilotms',
  'coqui',
  'crewai',
  'crusoe',
  'crystal',
  'csharp',
  'css3',
  'cursor',
  'cypress',
  'dalle',
  'dart',
  'datadog',
  'dbrx',
  'deepcogitoai',
  'deepinfra',
  'deepmind',
  'deepseek',
  'deno',
  'digitalocean',
  'django',
  'dlang',
  'doc2x',
  'docker',
  'docsearch',
  'docusaurus',
  'dojo',
  'doubao',
  'dovetail',
  'dphnAIai',
  'drizzle',
  'ec2',
  'edge',
  'elastic',
  'electron',
  'elementui',
  'elevenlabsai',
  'elixir',
  'ember',
  'erlang',
  'esbuild',
  'eslint',
  'essentialaiai',
  'exa',
  'expo',
  'expressjs',
  'fabricjs',
  'fastgpt',
  'faunadb',
  'featherless',
  'figma',
  'firebase',
  'firefly',
  'firefox',
  'fireworks',
  'fishaudioai',
  'flask',
  'flutter',
  'flutterflow',
  'fluxai',
  'flyio',
  'framer',
  'gatsby',
  'gcloud',
  'gemini',
  'gemma',
  'git',
  'github',
  'gitlab',
  'glmvai',
  'go',
  'google',
  'gradio',
  'grafana',
  'grafbase',
  'graphite',
  'graphql',
  'greptile',
  'gridsome',
  'grok',
  'groq',
  'gruntjs',
  'gsap',
  'gsap2',
  'gulp',
  'hailuo',
  'haskell',
  'headlessui',
  'heroku',
  'hexo',
  'hhvm',
  'higress',
  'homebrew',
  'hono',
  'hotjar',
  'html5',
  'huggingface',
  'hugo',
  'hunyuan',
  'hyper',
  'hyper2',
  'hyperbolic',
  'i18next',
  'id',
  'ie',
  'iflytekcloud',
  'inceptionai',
  'infermatic',
  'infinigence',
  'inflectionai',
  'inkspace',
  'insomnia',
  'internlm',
  'invision',
  'ionic',
  'jamstack',
  'java',
  'jest',
  'jimeng',
  'jina',
  'jira',
  'jquery',
  'js',
  'jslint',
  'json',
  'kibana',
  'kimi',
  'kling',
  'kluster',
  'kolorsai',
  'kotlin',
  'kubernetes',
  'kwaikatai',
  'kwaipilotai',
  'langchain',
  'langfuse',
  'langgraph',
  'langsmith',
  'laravel',
  'leptonai',
  'less',
  'lightroom',
  'linear',
  'linux',
  'liquidaiai',
  'lit',
  'liveblocks',
  'livekit',
  'llamaindex',
  'llava',
  'logrocket',
  'lokalise',
  'longcatai',
  'lovable',
  'lua',
  'luma',
  'lunacy',
  'magicai',
  'make',
  'mariadb',
  'marionette',
  'markdown',
  'materialui',
  'meta',
  'metaai',
  'microsoft',
  'minimax',
  'miro',
  'mistral',
  'mochajs',
  'modelscope',
  'mongodb',
  'mongoose',
  'monica',
  'morphai',
  'mozilla',
  'myshell',
  'mysql',
  'n8n',
  'neon',
  'neovim',
  'nestjs',
  'net',
  'netcore',
  'netlify',
  'netlify2',
  'nextjs',
  'nextjs2',
  'nim',
  'nitro',
  'nodejs',
  'notion',
  'nova',
  'novamodelai',
  'novita',
  'nplcloud',
  'npm',
  'npm2',
  'nuxtjs',
  'nvidia',
  'ocaml',
  'onedrive',
  'openai',
  'openchat',
  'opencode',
  'opera',
  'oracle',
  'palmai',
  'pandacss',
  'payload',
  'perplexity',
  'phidata',
  'phindai',
  'phoenix',
  'php',
  'pinia',
  'pixijs',
  'pixverse',
  'playwright',
  'poe',
  'postgresql',
  'posthog',
  'postman',
  'powershell',
  'ppio',
  'preact',
  'presto',
  'prettier',
  'prisma',
  'prometheus',
  'ps',
  'pugjs',
  'pwa',
  'pydanticai',
  'python',
  'pytorch',
  'pytorch3d',
  'qingyan',
  'qiniu',
  'qwen',
  'qwik',
  'radixui',
  'rails',
  'railway',
  'react',
  'reactquery',
  'reactrouter',
  'redhat',
  'redis',
  'redux',
  'reduxsaga',
  'redwoodjs',
  'relaceai',
  'remix',
  'render',
  'replit',
  'resend',
  'rollup',
  'roocode',
  'rovoai',
  'rsshub',
  'ruby',
  'rust',
  'rwkv',
  'safari',
  'sambanova',
  'sass',
  'scala',
  'search1api',
  'segment',
  'semanticui',
  'sensenova',
  'sentry',
  'serverless',
  'shadcnui',
  'siliconcloud',
  'sketch',
  'sketch2',
  'skyworkai',
  'slack',
  'snowflake',
  'snyk',
  'solidity',
  'solidjs',
  'soraai',
  'spark',
  'spring',
  'stability',
  'statecloud',
  'stepfun',
  'storyblok',
  'storybook',
  'strada',
  'stream',
  'streamlit',
  'stripe',
  'stylelint',
  'sublime',
  'supabase',
  'sveltejs',
  'swagger',
  'swift',
  'tRPC',
  'tailwindcss',
  'tanstack',
  'tanstack2',
  'targon',
  'techstackicons',
  'tencent',
  'tencentcloud',
  'terraform',
  'threejs',
  'tiangong',
  'tii',
  'tinyhttp',
  'together',
  'trello',
  'tripo',
  'turborepo',
  'twilio',
  'typescript',
  'ubuntu',
  'udio',
  'unjs',
  'unsplash',
  'unstructured',
  'upstage',
  'ur',
  'v0',
  'vercel',
  'vertexai',
  'vidu',
  'vim',
  'visualbasic',
  'vitejs',
  'vitest',
  'vllm',
  'volcengine',
  'voyage',
  'vscode',
  'vuejs',
  'webassembly',
  'webpack',
  'wenxin',
  'windsurf',
  'wordpress',
  'workersai',
  'xamarin',
  'xd',
  'xinference',
  'xuanyuan',
  'yi',
  'yoga',
  'yuanbao',
  'zapier',
  'zeabur',
  'zed',
  'zhipu',
  'zod',
  'zola',
] as const;

export type TechnologyIconName = (typeof SUPPORTED_ICON_NAMES)[number];
